import ErrorBoundary from '@/common/components/ErrorBoundary/ErrorBoundary';

export default ErrorBoundary;
